/* Avatar: rond lidkleurvlak; lokale kleuren via --mc-* (color.ts memberStyle). */
.avatar {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--mc-fill, var(--surface-sunken));
  color: var(--mc-ink, var(--text));
  text-align: center;
  overflow: hidden;
}

.picto {
  position: absolute;
  top: 14%;
  inset-inline-start: 14%;
  width: 72%;
  height: 72%;
  -webkit-user-drag: none;
}

.initial {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: var(--fw-650);
  line-height: 1;
}

.chip .initial {
  font-size: 15px;
}

.small .initial {
  font-size: 18px;
}

.medium .initial {
  font-size: 24px;
}

.default .initial {
  font-size: 30px;
}

.kid .initial {
  font-size: 42px;
}

/* Geselecteerd: ring in de volle tint met een rustige witte binnenrand (statisch, niet animeren). */
.selected {
  overflow: visible;
  box-shadow:
    0 0 0 3px var(--surface-panel),
    0 0 0 6px var(--mc-hue, var(--accent));
}

/* Rustige set (PictoImg als <svg>): de lijn in de lid-ink, niet in de pictogramkleur van het thema. */
.avatar .picto {
  color: var(--mc-ink, var(--text));
}

/* Thema Volwassen (boardThemes.css): rustige cirkel met de ledenkleur als dunne ring. De vulling is
   in dit thema al bijna neutraal; de initiaal of het lijnpictogram staat in de lid-ink. */
:global([data-board-theme='adult']) .avatar {
  box-shadow: inset 0 0 0 2px var(--mc-hue, var(--border-strong));
}

:global([data-board-theme='adult']) .selected {
  box-shadow:
    inset 0 0 0 2px var(--mc-hue, var(--border-strong)),
    0 0 0 3px var(--surface-panel),
    0 0 0 5px var(--mc-hue, var(--accent));
}

:global([data-board-theme='adult']) .initial {
  font-weight: 600;
}

/* Initialen (docs/ux/quick-wins): neutrale vulling, de ledenkleur alleen als dunne ring, de letter
   in de gewone tekstkleur en gewicht 600. Geldt overal waar geen gezicht hoort (alles behalve het
   thema Kinderen en de kindcontext in de ouderapp). */
.plain {
  background: var(--surface-sunken);
  color: var(--text);
  box-shadow: inset 0 0 0 2px var(--mc-hue, var(--border-strong));
}

.plain .initial {
  font-weight: 600;
}

.plain.selected {
  box-shadow:
    inset 0 0 0 2px var(--mc-hue, var(--border-strong)),
    0 0 0 3px var(--surface-panel),
    0 0 0 5px var(--accent);
}
